module.exports = __webpack_public_path__ + "img/RJMT_location_green.a31713d1.svg";